<template>
  <div>
    <v-select
      :label="$t('addShooting.selectModel')"
      v-model="selectedModel"
      return-object
      item-value="id"
      item-text="name"
      :items="filteredModels"
      clearable
      :rules="rules"
      @input="update"
    ></v-select>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SelectModel',

  data() {
    return {
      selectedModel: null
    }
  },

  computed: {
    ...mapState({
      format: (state) => state.newShooting.format,
      usersModels: (state) => state.usersConfig.usersModels
    }),
    filteredModels() {
      if (!this.usersModels || !this.format) return []
      return this.usersModels.filter((model) => model.format === this.format)
    },
    rules() {
      return [(v) => !!v || this.$t('rooms.form.required')]
    }
  },

  methods: {
    update(val) {
      this.$store.commit('UPDATE_MODEL', val)
      if (val) {
        this.$store.commit('SET_STAMPS', val.stamps || [])
      } else {
        this.$store.commit('SET_STAMPS', [])
      }
      this.$store.commit('UPDATE_STAMP', null)
      this.$store.commit('CLEAR_VIEW_IMAGES')
      this.autoSelectStampIfSingle(val)
    },
    autoSelectStampIfSingle(model) {
      if (model && model.stamps && model.stamps.length === 1) {
        this.$store.commit('UPDATE_STAMP', model.stamps[0])
      }
    }
  },

  watch: {
    format() {
      this.selectedModel = null
      this.$store.commit('UPDATE_MODEL', null)
      this.$store.commit('UPDATE_STAMP', null)
      this.$store.commit('CLEAR_VIEW_IMAGES')
    }
  }
}
</script>

<style lang="sass" scoped>
p
  text-align: center
  font-size: 16px
  color: rgba(0, 0, 0, 0.7)
</style>
